import { render, staticRenderFns } from "./formgroupswitch.vue?vue&type=template&id=c7c15068&"
import script from "./formgroupswitch.vue?vue&type=script&lang=js&"
export * from "./formgroupswitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports